import { updatePaybackPlanResponseSchema } from '@/api/paybackPlan/schemas';
import type { UpdatePaybackPlanPayload } from '@/api/paybackPlan/types';
import { apiRequest } from '@/api/utils/api';

export const updatePaybackPlan = (payload: UpdatePaybackPlanPayload) =>
  apiRequest({
    url: '/payback-plan',
    method: 'POST',
    schema: updatePaybackPlanResponseSchema,
    data: payload,
  });
